<template>
  <div id="app">
    <!-- <Head
     @isLogin="isLogin()"
     v-if="$route.path!= '/paypal'"
    :token="token"
    /> -->
    <keep-alive include="newsList">
      <router-view class="pt96"  />
    </keep-alive>
    <!-- <Footer/> -->
      <!-- Messenger 聊天插件 Code -->
    <div id="fb-root"></div>

    <!-- Your 聊天插件 code -->
    <div id="fb-customer-chat" class="fb-customerchat">
    </div>
  </div>
</template>

<script>
import Head from '@/components/head.vue';
import Footer from '@/components/footer.vue';
import {isEn} from '@/utils/util'
export default {
  components: { Head,Footer },
  name: "App",
  data () {
    return{
      token:localStorage.getItem('token')
    }
  },
   updated () {
    this.isLogin()
  },
  mounted () {
     if(this.isEn()){
        this.facebook()
      }
  },
  methods: {
    isEn,
     // facebook聊天组件
    facebook () {
        var chatbox = document.getElementById('fb-customer-chat');
        chatbox.setAttribute("page_id", "104140005369558");
        chatbox.setAttribute("attribution", "biz_inbox");

        window.fbAsyncInit = function() {
          FB.init({
            xfbml            : true,
            version          : 'v12.0'
          });
        };

        (function(d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s); js.id = id;
          js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    },
      // 检测是否登录
    isLogin () {
      this.token = localStorage.getItem('token')?localStorage.getItem('token'):''
    },
  },
 created() {
   if(this.isEn()){
     localStorage.setItem('locale','en')
      this.$i18n.locale = 'en'
   }else{
     localStorage.setItem('locale','zh')
     this.$i18n.locale = 'zh'
   }
  },
};
</script>

<style lang="less" scoped>

  #app {
    height: 100%;
    font-family: SFProDisplayMedium;
  }
  .pt96{
    // padding-top: 96px!important;
  }
// * {
//   touch-action: pan-y;
// }
// #app {
//   font-family: "Avenir", Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
// }
// body.modal-open {
//   position: fixed;
//   width: 100%;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue